import { render } from "./RequestFeed.vue?vue&type=template&id=67f6c1e3"
import script from "./RequestFeed.vue?vue&type=script&lang=js"
export * from "./RequestFeed.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__